<template>
    <v-container class="justify-center">
    <v-radio-group class="pb-2" v-model="radioGroup">
      <v-radio
        v-for="n in alts"
        :key="n.ID"
        :label="`${n.Label}`"
        :value="n"
      ></v-radio>
    </v-radio-group>
  </v-container>
</template>

<script>
export default {
    props: ['qAObject'],
    data() {
        return {
            radioGroup: 1,
            alts: [],
            isMandatory: 0, // Är obligatorisk 0 = nej, 1 = ja
            surveyValid: false
        }
    },
    watch: {
        radioGroup(val) {
            if(this.isMandatory === 1) {
                const radio = [val];
                if(radio.length > 0) {
                    this.surveyValid = true;
                } else {
                    this.surveyValid = false;
                }
            } else {
                this.surveyValid = true;
            }

            const answerObj = { 
                id: this.questionObject.SurveyID, // SurveyID
                question: this.questionObject.Topic, //  The actual question
                answer: val.Label, // the answer
                type: 'radio', // Type of alternativePicker
                answerId: val.ID, // unique answer id
                questionId: val.QuestionsID, // unique question id
                surveyValid: this.surveyValid,
                isMandatory: this.isMandatory

            };

            this.$store.dispatch('setSurvey', answerObj);
        }
    },
    mounted () {
        this.alts = this.$props.qAObject.alternatives;
        this.questionObject = this.$props.qAObject.question
        this.isMandatory = this.$props.qAObject.question.IsMandatory;
        console.log("isMandatory radio",this.isMandatory);
    }
}
</script>

<style>

</style>